import { useTranslation } from "react-i18next";
import { comparisonData } from "@/mocks/seo-data";

export default function ComparisonSection() {
  const { t } = useTranslation("home");

  return (
    <section className="bg-background-100 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-12">
          USFansSpreadsheet vs alternatywy
        </h2>

        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-background-300">
                <th className="py-4 pr-4 text-sm font-semibold text-foreground-700">
                  Funkcja
                </th>
                <th className="py-4 px-4 text-sm font-semibold text-primary-600 whitespace-nowrap">
                  USFansSpreadsheet
                </th>
                <th className="py-4 px-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">
                  Alternatywa A
                </th>
                <th className="py-4 pl-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">
                  Alternatywa B
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, i) => (
                <tr key={i} className="border-b border-background-200">
                  <td className="py-4 pr-4 text-sm text-foreground-700 font-medium">
                    {row.feature}
                  </td>
                  <td className="py-4 px-4 text-sm text-foreground-900 font-semibold">
                    {row.usfans}
                  </td>
                  <td className="py-4 px-4 text-sm text-foreground-500">
                    {row.alt1}
                  </td>
                  <td className="py-4 pl-4 text-sm text-foreground-500">
                    {row.alt2}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}